/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Select_Caption_TrackInputs */



/**
* | output |
* | --- |
* | "Please select a caption track" |
*
* @param {Embed_Captions_Select_Caption_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_select_caption_track = /** @type {((inputs?: Embed_Captions_Select_Caption_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Select_Caption_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner une piste de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Untertitelspur aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una traccia di sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите дорожку субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor seleccione una pista de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择字幕轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプショントラックを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया कैप्शन ट्रैक चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione uma faixa de legenda.")
	return /** @type {LocalizedString} */ ("Please select a caption track")
});